import artwork01 from './assets/images/artwork/01.jpg';
import artwork02 from './assets/images/artwork/02.jpg';
import artwork03 from './assets/images/artwork/03.jpg';
import artwork04 from './assets/images/artwork/04.jpg';
import artwork05 from './assets/images/artwork/05.jpg';
import artwork06 from './assets/images/artwork/06.jpg';

import audio01 from './assets/files/zh-HK/01.mp3';
import audio02 from './assets/files/zh-HK/02.mp3';
import audio03 from './assets/files/zh-HK/03.mp3';
import audio04 from './assets/files/zh-HK/04.mp3';
import audio05 from './assets/files/zh-HK/05.mp3';
import audio06 from './assets/files/zh-HK/06.mp3';

import audio01EN from './assets/files/en/01.mp3';
import audio02EN from './assets/files/en/02.mp3';
import audio03EN from './assets/files/en/03.mp3';
import audio04EN from './assets/files/en/04.mp3';
import audio05EN from './assets/files/en/05.mp3';
import audio06EN from './assets/files/en/06.mp3';


const STORIES = [
  {
    title: 'Cheung Chau @Hong Kong',
    desc: '2021<br/>80 x 110cm<br/>Giclée fine art print｜Ink + digital colour<br/>Edition：10',
    descEN: '',
    subTitle: '',
    imageSrc: artwork01,
    soundTrack: audio01,
    soundTrackEN: audio01EN
  },
  {
    title: 'Tokyo Tower @Tokyo',
    desc: '2022<br/>21.0 x 29.7 cm<br/>Giclée fine art print｜Ink + digital colour<br/>Edition：25',
    descEN: '',
    subTitle: '',
    imageSrc: artwork02,
    soundTrack: audio02,
    soundTrackEN: audio02EN
  },
  {
    title: 'Asakusa Tiger @Tokyo',
    desc: '2022<br/>80 x 110cm<br/>Giclée fine art print｜Ink + digital colour<br/>Edition：25',
    descEN: '',
    subTitle: '',
    imageSrc: artwork03,
    soundTrack: audio03,
    soundTrackEN: audio03EN
  },
  {
    title: 'Cat Shop @Tokyo',
    desc: '2022<br/>80 x 110cm<br/>Giclée fine art print｜Ink + digital colour<br/>Edition：25',
    descEN: '',
    subTitle: '',
    imageSrc: artwork04,
    soundTrack: audio04,
    soundTrackEN: audio04EN
  },
  {
    title: 'Fish eye @Intermission',
    desc: 'Gigi2021<br/>21.0 x 29.7 cm<br/>Giclée fine art print｜Ink + digital colour<br/>Edition：33',
    descEN: '',
    subTitle: '',
    imageSrc: artwork05,
    soundTrack: audio05,
    soundTrackEN: audio05EN
  },
  {
    title: 'Krzemionki @Kraków',
    desc: '2021<br/>80 x 110cm<br/>Giclée fine art print｜Ink + digital colour<br/>Edition：25',
    descEN: '',
    subTitle: '',
    imageSrc: artwork06,
    soundTrack: audio06,
    soundTrackEN: audio06EN
  }
];

export default STORIES;
